__turbopack_context__.v({
  "description": "_-module__s6Peta__description",
});
